import { render, staticRenderFns } from "./ApprovalReject.vue?vue&type=template&id=a5edacb2&scoped=true"
import script from "./ApprovalReject.vue?vue&type=script&lang=js"
export * from "./ApprovalReject.vue?vue&type=script&lang=js"
import style0 from "./ApprovalReject.vue?vue&type=style&index=0&id=a5edacb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5edacb2",
  null
  
)

export default component.exports